<template>
	<transition
		name="v-notice"
	    enter-active-class="animated fadeInDown"
	    leave-active-class="animated fadeOutUp">
		<div class="v-notice st-notice" :class="'st-notice--'+data.type">
			<div class="user-content-wrapper">
				<div v-if="data.type == 'system' || data.type == 'permission'" v-html="data.text"></div>
				<div v-else v-html="$t(data.text)"></div>
				<button v-if="data.removeAble" @click="close" :data-id="data.id" class="st-btn st-btn--right st-btn--sm"><span>X</span></button>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	name: 'v-notice',
	props: {
		data: {
			type: Object,
			default(){
				return {
					text: '',
					type: 'notice',
					removeAble: true,
				}
			}
		}
	},
	data(){
		return {
			count: 0,
			interval: false
		}
	},
	mounted(){
		let self = this;
		if(this.$store.getters['features/auto_hide_notifications'] || (!this.interval && this.data.autoRemove)){
			this.count = 10; //reset
			this.interval = window.setInterval(function(){
				self.count -= 1;
				if(self.count === 0){
					self.close(false, self.data.id);
					clearInterval(self.interval);
				}
			}, 1000);
		}
	},
	methods: {
		close(){
			this.$store.commit('REMOVE_NOTICE', this.data.id);
		}
	}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/v-notice.vue